module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-ppt-55ce3950208ad1e4812b627243e26587.svg";